
































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import PageNames from '@/router/PageNames';
import CreateWebhookRequest from '@/models/Settings/Webhooks/CreateWebhookRequest';
import { WebhooksModule } from '@/store/Settings/WebhooksModule';

@Component({ name: 'UserCreate' })
export default class extends SaascadaVueDialog {

    request: CreateWebhookRequest = new CreateWebhookRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateWebhookRequest();

            if (WebhooksModule.webhookEvents.length == 0) {
                WebhooksModule.getWebhookEvents();
            }
        }
    }

    get webhooks() {
        return WebhooksModule.webhookEvents;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            await WebhooksModule.createWebhook(this.request);

            if (WebhooksModule.newWebhookId !== null) {
                this.$router.push({ name: PageNames.Webhook, params: { id: WebhooksModule.newWebhookId } });
            }
        }
    }

}
